import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../../helpers/OutreachSearchContext';
import { getIsFetching } from '../../../../redux/Outreach/selectors/outreach';
import { getPaginationQueryOptions } from '../../../../redux/Outreach/selectors/outreach/pagination';
import { getSearchQueryForContext } from '../../../../redux/Outreach/selectors/components/search';
import { clearOutreaches } from '../../../../redux/Outreach/actions';
import {
  onChangeQuery,
  onClearQuery
} from '../../../../redux/Outreach/actions/components';
import { fetchOutreaches } from '../../../../redux/Outreach/sagas/routines';
import Search from '../../../../components/Outreach/Search';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.OUTREACH);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };

  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearOutreaches());
      dispatch(fetchOutreaches(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context: SEARCH_CONTEXT.OUTREACH, query }));
    },
    onClear: () => {
      dispatch(onClearQuery({ context: SEARCH_CONTEXT.OUTREACH }));
      dispatch(clearOutreaches());
      dispatch(fetchOutreaches({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);
